import StatusCode from 'status-code-enum';
import axios from 'axios';

import { useCarValuationToolContext } from '../../../../../../../../../components/PageWrappers/AdDetails/components/CarValuationTool/CarValuationTool.context';

import { Button } from '../../../../../../../../../components/Toolkit/Button';
import { Notification } from '../../../../../../../../../components/Toolkit/Notification/Notification';
import { ListNative } from '../../../../../../../../../components/ToolkitV2/ListNative/ListNative';
import { Text } from '../../../../../../../../../components/ToolkitV2/Text/Text';

import { Spacer } from '../../../../../../../../../helpers/genericStyles';

import * as Styled from './LookupError.styled';

type LookupErrorProps = {
  error: Error;
};

const LookupError = (props: LookupErrorProps) => {
  const { error } = props;

  const { registrationNumber, resetCarValuationForm } =
    useCarValuationToolContext();

  const carNotFound =
    axios.isAxiosError(error) &&
    (error.status === StatusCode.ClientErrorNotFound ||
      error.status === StatusCode.ClientErrorUnprocessableEntity);

  const lookupFailureReasons = [
    'You entered an invalid registration number',
    'Your car does not have an Irish registration',
    'Your car is more than 10 years old',
    'There’s not enough data',
    'Your vehicle is not a car',
    'You are not logged-in to DoneDeal',
  ];

  return (
    <Styled.Container>
      <div>
        <Notification intent="ERROR">
          <Text color="GREY_DARKER">
            {carNotFound ? (
              <>
                We couldn't find a valuation for your vehicle{' '}
                <b>{registrationNumber}.</b>
              </>
            ) : (
              'There was a problem processing your request - please try again.'
            )}
          </Text>
        </Notification>
        <Spacer marginBottom="M24" />
        {carNotFound && (
          <>
            <Text
              size="M16"
              responsiveSizes={{ medium: 'L18' }}
              weight="bold"
              color="GREY_DARKER"
            >
              This can happen for a number of reasons:
            </Text>
            <Spacer marginBottom="M16" />
            <ListNative name="Lookup failure reasons" markerSize="M16">
              {lookupFailureReasons.map((reason, index) => {
                return (
                  <Text
                    size="M16"
                    key={`lookup failure reason no.${index + 1}`}
                  >
                    {reason}
                  </Text>
                );
              })}
            </ListNative>
          </>
        )}
      </div>
      <Button ofType="SECONDARY" onClick={resetCarValuationForm}>
        Try again
      </Button>
    </Styled.Container>
  );
};

export { LookupError };
